import { mapState, mapGetters, mapActions } from "vuex";
import ConnectionPageTitle from "@/components/ConnectionPageTitle";
import AppCardConnections from "@/components/AppCardConnections";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import AppModal from "@/components/AppModal";
import { isObjectEmpty } from "@/utils";
import CustomSideBarAppModal from "@/components/CustomSideBarAppModal";
import CreateAccountSideBar from "@/components/CreateAccountSideBar";
import TasksMixin from "@/mixins/TasksMixin.vue";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import { country_codes } from "@/utils/countries";
export default {
  name: "AmazonAdvertisingPage",
  emits: ["update-total"],
  mixins: [AccountsMixin, TasksMixin],
  components: {
    ConnectionPageTitle,
    AppCardConnections,
    AppButton,
    AppModal,
    AppIcon,
    CustomSideBarAppModal,
    CreateAccountSideBar
  },
  data() {
    return {
      provider: "Amazon Advertising",
      searchPlaceHolder: "Search",
      accountsList: [],
      countries: {
        "": [{
          text: "Choose a country",
          value: ""
        }],
        "North America": [{
          text: "Brazil",
          value: "Brazil"
        }, {
          text: "US",
          value: "US"
        }, {
          text: "Mexico",
          value: "Mexico"
        }, {
          text: "Canada",
          value: "Canada"
        }],
        "Europe & Middle East": [{
          text: "Spain",
          value: "Spain"
        }, {
          text: "Belgium",
          value: "Belgium"
        }, {
          text: "UK",
          value: "UK"
        }, {
          text: "France",
          value: "France"
        }, {
          text: "Netherlands",
          value: "Netherlands"
        }, {
          text: "Germany",
          value: "Germany"
        }, {
          text: "Italy",
          value: "Italy"
        }, {
          text: "Sweden",
          value: "Sweden"
        }, {
          text: "Egypt",
          value: "Egypt"
        }, {
          text: "Poland",
          value: "Poland"
        }, {
          text: "Turkey",
          value: "Turkey"
        }, {
          text: "Saudi Arabia",
          value: "Saudi Arabia"
        }, {
          text: "U.A.E",
          value: "U.A.E"
        }, {
          text: "India",
          value: "India"
        }, {
          text: "Ireland",
          value: "Ireland"
        }],
        "Far East": [{
          text: "Singapore",
          value: "Singapore"
        }, {
          text: "Australia",
          value: "Australia"
        }, {
          text: "Japan",
          value: "Japan"
        }]
      },
      accountRemoveTaskIdentifier: "",
      dataLoading: true,
      removeLoading: false,
      confirmRemoveModal: false,
      removeId: null,
      createAccountSideBar: false,
      regions: [{
        text: "Choose a region to connect",
        value: ""
      }, {
        text: "North America",
        value: "North America"
      }, {
        text: "Europe & Middle East",
        value: "Europe & Middle East"
      }, {
        text: "Far East",
        value: "Far East"
      }]
    };
  },
  props: {
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      isClientAdmin: state => state.auth.isClientAdmin,
      isClientUser: state => state.auth.isClientUser,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      current_workspace: state => state.workspace.current_workspace,
      account: state => state.account.list
    }),
    ...mapGetters(["accountAdvertisingGet", "accountByProviderGet", "workspaceNameById", "getCountryFlag", "accountAdvertisingBySellerIdGet"]),
    canAddAccount() {
      return (this.isOmnyAdmin || this.isClientAdmin || this.isOmnyUser || this.isClientUser) && !this.isOmnyWorkspace && this.accounts.length > 1;
    },
    // isLoggedIn() {
    //   return !! this.token
    // },

    accounts() {
      this.accountsList = this.account.filter(a => a.account_provider != "Amazon Advertising" && a.account_provider != "Amazon DSP Advertising").sort((a, b) => b.account_id > a.account_id);
      const startIndex = (this.page - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.accountsList.slice(startIndex, endIndex);
    }
  },
  async mounted() {
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      await this.refreshAccountList();
      this.dataLoading = false;
      window.$bus.on("refreshAccountList", this.refreshAccountList);
      //console.log("[advertising page mounted]");
      this.updateTotalData();
      this.checkIfAnyPreviousAccountRemoveTaskIsRunning();
    }
  },
  async created() {
    //this.provider = this.account_provider_mapping[this.$route.matched[1].path];
    let currentBreadCrumbs = this.$store.getters.getCurrentBreadCrumbs();
    currentBreadCrumbs[currentBreadCrumbs.length - 1].text = this.provider;
    this.$store.dispatch("setBreadcrumbs", currentBreadCrumbs);
  },
  methods: {
    ...mapActions(["accountList", "accountRemove", "authStatus", "getAdvertisingAccounts"]),
    onRemove(account) {
      this.removeId = account.account_id;
      this.confirmRemoveModal = true;
    },
    workspaceName(workspace_id) {
      let found_workspace = this.workspaceNameById(workspace_id);
      return found_workspace ? found_workspace : "";
    },
    handleIdle() {
      this.removeLoading = false;
    },
    handleFailed() {
      this.removeLoading = false;
    },
    handleRunning() {
      this.removeLoading = true;
      this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
    },
    handleFinished(data) {
      this.removeLoading = false;
      this.removeId = null;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      ;
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: data.task_status + data.task_result.status,
        delay: 60 // Show alert less than 1 minute
      });
      this.refreshAccountList();
    },
    checkIfAnyPreviousAccountRemoveTaskIsRunning() {
      for (const account in this.accounts) {
        this.removeId = account.account_id;
        this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + account.account_id + "_" + "accounts_delete";
        this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
        this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
        for (const profile in this.accountAdvertisingBySellerIdGet(account.account_id)) {
          this.removeId = profile.account_id;
          this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + profile.account_id + "_" + "accounts_delete";
          this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
          this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
        }
      }
      ;
    },
    async onRemoveConfirm() {
      this.confirmRemoveModal = false;
      this.removeLoading = true;
      let advertisingAccounts = this.accountAdvertisingBySellerIdGet(this.removeId);
      let seller_list = [{
        account_id: this.removeId.toString()
      }, ...advertisingAccounts].map(item => {
        return {
          account_id: item.account_id.toString()
        };
      });
      this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "accounts_delete";
      let account_remove_task = await this.accountRemove({
        seller_list: seller_list,
        task_identifier_omny: this.accountRemoveTaskIdentifier,
        workspace_id: this.current_workspace.workspace_id.toString()
      });
      this.getAsyncUpdate(account_remove_task.task_id);
      this.checkTaskStatusPeriodically(account_remove_task.task_id);
    },
    async refreshAccountList() {
      let data = {};
      await this.accountList(data);
    },
    updateTotalData() {
      this.$emit('update-total', {
        totalPages: this.accountsList.length
      });
    }
  }
};